import { createContext, useState, useCallback, useContext } from "react";
import api from "../api";
import { auth } from "../firebase";
import { AuthContext } from "./authContext";

export const Datacontext = createContext();

export const DataProvider = ({ children }) => {
  const { logout } = useContext(AuthContext)
  const [loading, setLoading] = useState(false);
  const [clients, set_clients] = useState([]);
  const [appClients, set_AppClients] = useState([]);
  const [users, setUsers] = useState([]);
  const [village, setVillage] = useState([]);
  const [offices, setOffice] = useState([]);
  const [docs, setDocs] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [ecs, set_Ecs] = useState([]);
  const [nls, set_Nls] = useState([]);
  const [marquee, setMarquee] = useState({});
  const [doc_Count, set_Doc_Count] = useState({});
  const [ec_Count, set_Ec_Count] = useState({});
  const [nl_Count, set_Nl_Count] = useState({});
  const [client_Count, set_Client_Count] = useState({});
  const [user_Count, set_User_Count] = useState({});
  const [ sZone, set_SZone ] = useState([])
  const [ sVillage, set_SVillage ] = useState([])
  const [ sOffice, set_SOffice ] = useState([])
  const [ sLayout, set_SLayout ] = useState([])
  const [ branches, set_Branches ] = useState([])

  // 1. Session Refresh Logic
  const handleAuthError = useCallback(async () => {
    console.warn("Session expired. Attempting to refresh...");
    try {
      const freshToken = await auth.currentUser.getIdToken(true);
      sessionStorage.setItem("token", freshToken);
    } catch (refreshErr) {
      console.error("Refresh failed. Logging out.");
      logout()
    }
  }, [logout]);

  // 2. Centralized Request Wrapper
  // This handles the 401 check for every fetch function automatically
  const handleRequest = useCallback(async (requestFn) => {
    try {
      await requestFn();
    } catch (error) {
      console.error("API Error:", error);
      if (error.response?.status === 401) {
        await handleAuthError();
      }
    }
  }, [handleAuthError]);

  // 3. Individual Fetch Functions
  const fetchClients = useCallback(() => handleRequest(async () => {
    const { data } = await api.get("/view");
    const sorted = [...(data.users || [])].sort((a, b) => a.cid.localeCompare(b.cid));
    set_clients(sorted);
  }), [handleRequest]);

  const fetchAppClients = useCallback(() => handleRequest(async () => {
    const { data } = await api.get("/view_app");
    const sorted = [...(data.users || [])].sort((a, b) => a.name.localeCompare(b.name));
    set_AppClients(sorted);
  }), [handleRequest]);

  const fetchUsers = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/view_user');
    setUsers(data.users || []);
  }), [handleRequest]);

  const fetchVill = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/view_Village');
    setVillage(data.villages || []);
  }), [handleRequest]);

  const fetchOffices = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/view_Register_Office');
    setOffice(data.offices || []);
  }), [handleRequest]);

  const fetchDocs = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/view_Document');
    setDocs(data.documents || []);
  }), [handleRequest]);

  const fetchBranches = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/viewbranch');
    set_Branches(data.branches || []);
  }), [handleRequest]);

  const fetchMarqee = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/view_mar');
    setMarquee(data.marqee?.[0] || {});
  }), [handleRequest]);

  const fetchDocuments = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/view_Customer');
    setDocuments(data.reg_docs || []);
  }), [handleRequest]);

  const fetchEc = useCallback(() => handleRequest(async () => {
    const { data } = await api.get("/view_ec");
    set_Ecs(data.reg_ec || []);
  }), [handleRequest]);

  const fetchNl = useCallback(() => handleRequest(async () => {
    const { data } = await api.get("/view_nl");
    set_Nls(data.reg_nl || []);
  }), [handleRequest]);

  const fetchcountdoc = useCallback(() => handleRequest(async () => {
    const currentYear = new Date().getFullYear().toString();
    const { data } = await api.get('/doc_countg', {
      params: { year: currentYear }
    });
    set_Doc_Count(data)
  }), [handleRequest]);

  const fetchcountec = useCallback(() => handleRequest(async () => {
    const currentYear = new Date().getFullYear().toString();
    const { data } = await api.get('/ec_countg', {
      params: { year: currentYear }
    });
    set_Ec_Count(data)
  }), [handleRequest]);

  const fetchcountnl = useCallback(() => handleRequest(async () => {
    const currentYear = new Date().getFullYear().toString();
    const { data } = await api.get('/nl_countg', {
      params: { year: currentYear }
    });
    set_Nl_Count(data)
  }), [handleRequest]);

  const fetchcountclient = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/client_countg');
    set_Client_Count(data)
  }), [handleRequest]);

  const fetchcountuser = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/user_countg');
    set_User_Count(data)
  }), [handleRequest]);

  const fetchSZone = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/get_v_s?type=zone');
    set_SZone(data.data)
  }), [handleRequest]);

  const fetchSOffice = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/get_v_s?type=office');
    set_SOffice(data.data)
  }), [handleRequest]);

  const fetchSVillage = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/get_v_s?type=village');
    set_SVillage(data.data)
  }), [handleRequest]);

  const fetchSLayout = useCallback(() => handleRequest(async () => {
    const { data } = await api.get('/get_v_s?type=layout');
    set_SLayout(data.data)
  }), [handleRequest]);

  // 4. The Trigger: Listen for Login/Logout
  const initData = useCallback(async () => {
    setLoading(true);
    try {
      await Promise.all([
        fetchClients(), fetchVill(), fetchUsers(), fetchOffices(),fetchDocs(), 
        fetchDocuments(), fetchMarqee(), fetchNl(), fetchcountclient(), fetchcountuser(), 
        fetchEc(), fetchcountdoc(), fetchcountec(), fetchcountnl(), fetchSOffice(), 
        fetchSVillage(), fetchSZone(), fetchSLayout(), fetchBranches(), fetchAppClients()
      ]);
    } finally {
      setLoading(false);
    }
  }, [fetchClients, fetchVill, fetchUsers, fetchcountec, fetchcountnl, fetchOffices, fetchDocs, fetchDocuments, fetchcountdoc, 
    fetchMarqee, fetchNl, fetchEc, fetchSOffice, fetchSVillage, fetchSZone, fetchSLayout, fetchcountclient, fetchcountuser, fetchBranches, fetchAppClients]);

  // Add initData to the Provider value
  return <Datacontext.Provider value={{
    clients, users, village, offices, docs, documents, marquee, ecs, nls,
    fetchNl, fetchEc, fetchMarqee, fetchDocuments, fetchDocs, fetchOffices,
    fetchVill, fetchUsers, fetchClients, doc_Count, ec_Count, nl_Count, client_Count, user_Count, 
    fetchcountclient, fetchcountuser, fetchcountec, fetchcountnl, fetchcountdoc, loading, initData,
    fetchSOffice, sOffice, fetchSVillage, sVillage, fetchSZone, sZone, fetchSLayout, sLayout, fetchBranches, branches, fetchAppClients, appClients
  }}>{children}</Datacontext.Provider>
};
